document.addEventListener("DOMContentLoaded", () => {
	const productPriceAttribute = "data-price";
	const productCatalogNumberAttribute = "data-catalog-number";
	const productSizeAttribute = "data-size";
	const productDisplayNameAttribute = "data-display-name";

	const productData = {
		"@context": "http://schema.org/",
		"@type": "Product",
		brand: {
			"@type": "Brand",
			name: "Promega",
		},
		offers: [],
	};

	const isNotEmptyOrSpace = (str) => {
		return str.trim().length > 0;
	};

	function stripHtmlAndEntities(htmlString) {
		// Create a temporary DOM element to leverage the browser's HTML parser
		const tempDiv = document.createElement("div");
		// Assign the HTML string to the innerHTML property of the temporary element
		tempDiv.innerHTML = htmlString;
		// Extract the text content, stripping tags and decoding entities
		return tempDiv.textContent || tempDiv.innerText || "";
	}

	const getCookie = (name) => {
		let cookieArr = document.cookie.split(";");
		for (let i = 0; i < cookieArr.length; i++) {
			let cookiePair = cookieArr[i].split("=");
			if (name == cookiePair[0].trim()) {
				return decodeURIComponent(cookiePair[1]);
			}
		}
		return null;
	};

	const getProductName = (nameElement) => {
		if (nameElement) {
			if (isNotEmptyOrSpace(nameElement.textContent)) {
				return nameElement.textContent;
			}
		}
		return false;
	};

	const getProductImage = (imageElement) => {
		if (imageElement) {
			if (isNotEmptyOrSpace(imageElement.src)) {
				return imageElement.src;
			}
		}
		return false;
	};

	const parseProductData = (products) => {
		for (let i = 0; i < products.length; i++) {
			const currentProduct = products[i]; // Corrected typo 'prodcuts' to 'products'

			const productCatalogNumber = currentProduct.getAttribute(productCatalogNumberAttribute);
			if (!productCatalogNumber) {
				continue;
			}

			const productName = currentProduct.getAttribute(productDisplayNameAttribute);
			if (!productName) {
				continue;
			}
			const strippedProductName = stripHtmlAndEntities(productName);
			if (!isNotEmptyOrSpace(strippedProductName)) {
				continue;
			}

			const productPrice = currentProduct.getAttribute(productPriceAttribute);
			const productPriceData = getPriceData(productPrice);
			if (!productPriceData) {
				continue;
			}
			const productPriceCurrency = productPriceData.currencyISO;
			const productPriceValue = productPriceData.priceData;

			const productSize = currentProduct.getAttribute(productSizeAttribute);

			const imageElement = document.querySelector(`#ProductImage${productCatalogNumber}`);
			const productImage = getProductImage(imageElement);

			const offer = buildOfferData(
				productCatalogNumber,
				strippedProductName,
				productPriceCurrency,
				productPriceValue,
				productSize,
				productImage
			);

			productData.offers.push(offer);
		}
	};

	const buildOfferData = (sku, name, priceCurrency, price, size = null, image = null) => {
		const offer = {
			"@type": "Offer",
			sku: sku,
			name: name,
			priceCurrency: priceCurrency,
			price: price,
			availability: "http://schema.org/InStock",
			itemCondition: "http://schema.org/NewCondition",
		};

		if (image) {
			offer.image = image;
		}

		if (size) {
			offer.size = size;
		}

		return offer;
	};

	const getPriceData = (priceElement) => {
		if (priceElement) {
			const currencyRawMatches = priceElement.match(/^[^\d]*/);
			const priceRawMatches = priceElement.match(/\d[\d\s,\.]*/);
			const priceRaw = priceRawMatches ? priceRawMatches[0] : false;
			const currencyRaw = currencyRawMatches ? currencyRawMatches[0].trim() : false;

			let priceData;
			let currencyISO;
			if (priceRaw) {
				priceData = priceRaw
					.replace(/\u00A0/g, "")
					.trim()
					.replace(/\.(?!.{0,2}$)/g, "")
					.replace(/,(?=\d{2}$)/, ".")
					.replace(/,(?=.*.{3})/g, "")
					.replace(/\s/g, "");
			}

			if (currencyRaw && parseFloat(priceData) > 0) {
				currencyISO = getCurrencyISO(currencyRaw);
				if (currencyISO) {
					return { priceData, currencyISO };
				}
			}
		}
		return false;
	};

	const getCurrencyISO = (currencySymbol) => {
		let currencySymbolStripped = currencySymbol
			.replace(/&nbsp;/gi, " ") // Replace non-breaking spaces
			.replace(/&amp;/gi, "&") // Replace ampersands
			.replace(/&lt;/gi, "<") // Replace less than signs
			.replace(/&gt;/gi, ">")
			.trim();

		const symbolMap = {
			A$: "AUD",
			$: "USD",
			"€": "EUR",
			"£": "GBP",
			"₩": "KRW",
			R$: "BRL",
			C$: "CAD",
			CHF: "CHF",
			DKK: "DKK",
			"₹": "INR",
			SEK: "SEK",
			NOK: "NOK",
			zł: "PLN",
			S$: "SGD",
		};

		if (currencySymbolStripped === "¥") {
			const countryCookie = getCookie("PromegaCountry");
			if (countryCookie) {
				return countryCookie === "JPN" ? "JPY" : "CNY";
			}
		}
		return symbolMap[currencySymbolStripped] || false;
	};

	const appendScript = (scriptData) => {
		const script = document.createElement("script");
		script.setAttribute("type", "application/ld+json");
		script.textContent = JSON.stringify(scriptData);
		if (scriptData.offers.length > 0) {
			document.head.appendChild(script);
		}
	};

	const setMainProductData = () => {
		const nameElement = document.querySelector(".product-title");
		const productName = getProductName(nameElement);
		if (productName) {
			productData.name = productName;
		} else {
			return false;
		}

		const imageElements = document.querySelectorAll(".product_image");
		if (imageElements.length > 0) {
			const firstProductImage = getProductImage(imageElements[0]);
			if (firstProductImage) {
				productData.image = firstProductImage;
			}
		} else {
			return false;
		}

		const productDescriptionElement = document.querySelector(".product-details__product-tagline");
		if (productDescriptionElement) {
			if (isNotEmptyOrSpace(productDescriptionElement.textContent)) {
				productData.description = productDescriptionElement.textContent;
			}
		}
		return true;
	};

	const init = () => {
		const mainProductSet = setMainProductData();
		if (!mainProductSet) {
			return;
		}
		const products = document.querySelectorAll("[data-catalog-number]");
		parseProductData(products);
		if (productData.offers.length > 0) {
			appendScript(productData);
		} else {
		}
	};
	init();
});